import {Routes} from '@angular/router';
import { Library } from './features/user/library/library';
import { Manager } from './features/manager/manager';
import { Playlists } from './features/user/playlists/playlists';
import { Users } from './features/manager/users/users';
import { Tracks } from './features/manager/tracks/tracks';
import { ManagerPlaylists } from './features/manager/playlists/playlists';
import { Genres } from './features/manager/genres/genres';
import { Subgenres } from './features/manager/subgenres/subgenres';
import { Categories } from './features/manager/categories/categories';
import { Dashboard } from './features/manager/dashboard/dashboard';
import { CarouselImages } from './features/manager/carousel-images/carousel-images';
import { Login } from './components/login/login';
import { AuthGuard } from '@data-access/guards/auth.guard';
import { Signup } from './components/signup/signup';
import { Terms } from './components/terms/terms';
import { ForgotPassword } from './components/forgot-password/forgot-password';
import { AdminAuthGuard } from '@data-access/guards/admin-auth.guard';
import { Success } from './components/success/success';
import { Profile } from './features/user/profile/profile';
import { Policy } from './components/policy/policy';
import { CookiePolicy } from './components/cookie-policy/cookie-policy';
import { RefundPolicy } from './components/refund-policy/refund-policy';
import { AboutUs } from './components/about-us/about-us';
import { SetNewPassword } from './components/set-new-password/set-new-password';
import { PlaylistTracks } from './features/user/playlist-tracks/playlist-tracks';
import { Faq } from './components/faq/faq';
import { ContactUs } from './components/contact-us/contact-us';
import { Dmca } from './components/dmca/dmca';

export const routes: Routes = [
  {path: '', component: Login},
  {path: 'login', component: Login},
  {path: 'forgot-password', component: ForgotPassword},
  {path: 'set-password', component: SetNewPassword},
  {path: 'terms-and-conditions', component: Terms},
  {path: 'privacy-policy', component: Policy},
  {path: 'cookie-policy', component: CookiePolicy},
  {path: 'refund-policy', component: RefundPolicy},
  {path: 'about-us', component: AboutUs},
  {path: 'faq', component: Faq},
  {path: 'contact-us', component: ContactUs},
  {path: 'dmca', component: Dmca},
  {path: 'sign-up', component: Signup},
  {path: 'apply', component: Signup},
  {path: 'success', component: Success},
  {path: 'library', component: Library, canActivate: [AuthGuard]},
  {path: 'playlists', component: Playlists, canActivate: [AuthGuard]},
  {path: 'playlists/:id', component: PlaylistTracks, canActivate: [AuthGuard]},
  {path: 'profile', component: Profile, canActivate: [AuthGuard]},
  {
    path: 'admin',
    component: Manager,

    children: [
      { path: '', component: Tracks, canActivate: [AdminAuthGuard], },
      { path: 'dashboard', component: Dashboard, canActivate: [AdminAuthGuard], },
      { path: 'users', component: Users, canActivate: [AdminAuthGuard], },
      { path: 'tracks', component: Tracks, canActivate: [AdminAuthGuard], },
      { path: 'playlists', component: ManagerPlaylists, canActivate: [AdminAuthGuard] },
      { path: 'genres', component: Genres, canActivate: [AdminAuthGuard] },
      { path: 'subgenres', component: Subgenres, canActivate: [AdminAuthGuard] },
      { path: 'categories', component: Categories, canActivate: [AdminAuthGuard] },
      { path: 'carousel-images', component: CarouselImages, canActivate: [AdminAuthGuard] },
    ]
  },
  { path: '**', redirectTo: 'login' }
];
